import { render, staticRenderFns } from "./OverviewOrder.vue?vue&type=template&id=f573fb60&scoped=true&"
import script from "./OverviewOrder.vue?vue&type=script&lang=js&"
export * from "./OverviewOrder.vue?vue&type=script&lang=js&"
import style0 from "./OverviewOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OverviewOrder.vue?vue&type=style&index=1&id=f573fb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f573fb60",
  null
  
)

export default component.exports